import { render } from "./GroupMemberInfo.vue?vue&type=template&id=1b3390eb&scoped=true"
import script from "./GroupMemberInfo.vue?vue&type=script&lang=js"
export * from "./GroupMemberInfo.vue?vue&type=script&lang=js"

import "../../styles/van-sticky-nav.css?vue&type=style&index=0&lang=css"
import "./GroupMemberInfo.vue?vue&type=style&index=1&id=1b3390eb&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3390eb"]])

export default __exports__